import React, { useState } from 'react'
import Sidebar from '../Sidebar/index'
import Navbar from '../Navbar/index'
import "./Hero2.css"

const HeroSection2 = () => {
   const [isOpen, setIsOpen] = useState(false)
    
   const toggle = () => {
    setIsOpen(!isOpen)
   }
  return (
    <>
    <div id='home' className='HeroContainer2'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='HeroBg2'>
          <Navbar toggle={toggle}/>
        </div>
    </div>
    </>
  )
}

export default HeroSection2